export default __webpack_public_path__ + "static/media/nft-9.0d425ac3.png";